import { useRef, useEffect, useState } from 'react';

export function useDynamicColumnCount({ breakpoints = [800, 1200], columns = [1, 2, 3] }) {
  const containerRef = useRef(null);
  const [columnCount, setColumnCount] = useState(columns[0]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateColumnCount = () => {
      const width = container.offsetWidth;      
      for (let i = breakpoints.length - 1; i >= 0; i--) {
        const breakpoint = breakpoints[i];
        if (width > breakpoint) {
          setColumnCount(columns[i + 1]);
          return;
        }
      }  
      setColumnCount(columns[0]);
    };

    updateColumnCount();

    const resizeObserver = new ResizeObserver(updateColumnCount);
    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [breakpoints, columns]);

  return { containerRef, columnCount };
}
